import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/Benefits.module.css';

const benefits = {
  promotion: {
    title: '오픈 프로모션',
    items: [
      '데이터 이전 전면 지원',
      '센터 브랜딩 페이지 무료 제작',
      '상품 사진/영상 전문 편집/촬영 지원'
    ],
    note: '*추후 협의 후 연장 가능'
  },
  growth: {
    title: '센터 성장 지원',
    items: [
      '분기별 1회 경영 세미나 (세무/노무/마케팅)',
      '전문가 1:1 컨설팅 무료 쿠폰 제공',
      '성공 사례 네트워킹'
    ]
  }
};

export default function Benefits() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="benefits" ref={ref} className={`section ${styles.benefits}`}>
      <div className="section-content">
        <h2 className="text-center">올림 입점 파트너 특별 혜택 기간</h2>
        <p className={`${styles.subtitle} text-center`}>
          센터가 성공해야 올림이 성공합니다. 함께 만들어가겠습니다
        </p>

        <div className={`${styles.cards} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>{benefits.promotion.title}</h3>
            <ul className={styles.list}>
              {benefits.promotion.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            {benefits.promotion.note && (
              <p className={styles.note}>{benefits.promotion.note}</p>
            )}
          </div>

          <div className={styles.card}>
            <h3 className={styles.cardTitle}>{benefits.growth.title}</h3>
            <ul className={styles.list}>
              {benefits.growth.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
